import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  link: {
    color: 'blue',
    cursor: 'pointer',
    textDecoration: 'underline',
    padding: '5px 0px',
  },
}));

